import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./admin.css";

export default function FMSRegister() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const API = process.env.REACT_APP_API_URL;

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    try {
      const res = await fetch(`${API}/api/admin/fms/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(data.message || "Registration failed");
      }

      setSuccess("Request submitted. The super admin will review and approve your account.");
      setTimeout(() => navigate("/admin/login"), 2000);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="admin-login-container">
      <h1>FMS Team Registration</h1>

      {error && <p className="admin-error">{error}</p>}
      {success && <p className="notice-success">{success}</p>}

      <form onSubmit={handleSubmit} className="admin-login-form">
        <input
          name="name"
          placeholder="Full name"
          value={form.name}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          required
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          value={form.password}
          onChange={handleChange}
          required
        />
        <button type="submit">Submit for approval</button>
      </form>

      <p className="tower-admin-link">
        <a href="/">← Back to Crown Residences</a>
      </p>
    </div>
  );
}